import { FC } from "react";

import {
	FieldLayout,
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FieldWrapper } from "../../FieldWrapper/FieldWrapper";
import { RHookFormNumericFormatTextField } from "../../TaxSlipDataInput/RHookFormNumericFormatTextField";

interface IQPIPSetupFieldsPanel {}
export const QPIPSetupFieldsPanel: FC<IQPIPSetupFieldsPanel> = ({}) => {
	return (
		<div>
			<RHookFormNumberFieldWithLabel
				label="Max. Innsurable Annual Earnings"
				id="maxInsurableAnnualEarnings"
				testId={`Max-Innsurable-Annual-Earnings`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				label="Max. Annual Premium"
				id="maxAnnualPremium"
				testId={`Max.-Annual-Premium`}
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id="premiumRate"
				testId="premiu-mRate"
				label="Premium Rate"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
			<RHookFormNumberFieldWithLabel
				id={"employerContribution"}
				label="Employer Contribution"
				testId="Employer-Contribution"
				labelPosition={LabelPosition.Top}
				maxFractionDigits={10}
			/>
		</div>
	);
};
